<template>
    <v-layout row wrap>
        <v-flex xs12 sm12 md10 lg8 xl7 class="pa-2">
            <v-snackbar
                    v-model="consents_saved"
                    color="success"
                    top
            >
                Privolitve so bile uspešno shranjene.
                <v-btn
                        flat
                        @click="consents_saved = false"
                >
                    Zapri
                </v-btn>
            </v-snackbar>
            <v-snackbar
                    v-model="errorSaving"
                    color="error"
                    top
            >
                {{ errorSavingMsg }}
                <v-btn
                        flat
                        @click="errorSaving = null"
                >
                    Zapri
                </v-btn>
            </v-snackbar>
            <consents-editor :for_registration="false" v-on:saved="consents_saved=true" v-on:error="onErrorSaving($event)"></consents-editor>
        </v-flex>
    </v-layout>
</template>

<script>
    import ConsentsEditor from "../ConsentsEditor";
    export default {
        name: "ConsentsTab.vue",
        components: {ConsentsEditor},
        data: vm => ({
            loading: false,
            consents_saved: false,
            errorSaving: false,
            errorSavingMsg: null
        }),
        methods: {
            onErrorSaving(data){
                this.errorSaving = true;
                this.errorSavingMsg = data['message'];
            }
        }
    }
</script>

<style scoped>

</style>